// Import all required modules

import SidebarAnimation from '@bs/components/views/SidebarAnimation';
import HeroVideos from '@bs/components/views/HeroVideos';
import HeroDropdown from '@bs/components/views/HeroDropdown';
import InteriorHero from '@bs/components/views/InteriorHero';
import Lightbox from '@bs/components/views/Lightbox';
import LandingHero from '@bs/components/views/LandingHero';
import BodyVideo from '@bs/components/views/BodyVideo';
import StatsPie from '@bs/components/views/StatsPie';
import StatsPercentageCounter from '@bs/components/views/StatsPercentageCounter';
import Donut from '@bs/components/views/Donut';
import DonateBox from '@bs/components/views/DonateBox';
import StatsFwPie from '@bs/components/views/StatsFwPie';
import FwStatCounter from '@bs/components/views/FwStatCounter';
import FeaturedContent from '@bs/components/views/FeaturedContent';
import StatisticsAnimation from '@bs/components/views/StatisticsAnimation';
import BodyBackgroundObserver from '@bs/components/views/BodyBackgroundObserver';
import Header from '@bs/components/views/Header';
import FooterPie from '@bs/components/views/FooterPie';
import BackToTop from '@bs/components/views/BackToTop';
import LinkListing from '@bs/components/views/LinkListing';
import ListingCards from '@bs/components/views/ListingCards';
import EmailBlock from '@bs/components/views/EmailBlock';
import CtaBlock from '@bs/components/views/CtaBlock';
import HomeEmailBlock from '@bs/components/views/HomeEmailBlock';
import Dropdown from '@bs/components/views/Dropdown';
import CountrySidebarHeight from '@bs/components/views/CountrySidebarHeight';
import VideoTwoThreeUp from '@bs/components/views/VideoTwoThreeUp';
import Slideshow from '@bs/components/views/Slideshow';
import TabComponent from '@bs/components/views/TabComponent';
import SocialHighlights from '@bs/components/views/SocialHighlights';
import Callouts from '@bs/components/views/Callouts';
import Flagship from '@bs/components/views/Flagship';
import ImageScroll from '@bs/components/views/ImageScroll';
import Timeline from '@bs/components/views/Timeline';
import Accordion from '@bs/components/views/Accordion';
import EventSignupForm from '@bs/components/views/EventSignupForm';
import EmbedForm from '@bs/components/views/EmbedForm';
import StoryNavigation from '@bs/components/views/StoryNavigation';
import MapRegions from '@bs/components/views/MapRegions';
import WorkMap from '@bs/components/views/WorkMap';
import AlertFooter from '@bs/components/views/AlertFooter';
import Alert from '@bs/components/views/Alert';
import GeoLocationPopup from '@bs/components/views/GeoLocationPopup';
import SideNavigation from '@bs/components/views/SideNavigation';
import MegaBanner from '@bs/components/views/MegaBanner';
import ResourceSidebar from '@bs/components/views/ResourceSidebar';
import CampaignHero from '@bs/components/views/CampaignHero';
import ImageGalleryGrid from '@bs/components/views/ImageGalleryGrid';
import Snapshot from '@bs/components/views/Snapshot';
import HighlightComponent from '@bs/components/views/HighlightComponent';
import EmergencyStatistics from '@bs/components/views/EmergencyStatistics';
import QuoteComponent from '@bs/components/views/QuoteComponent';
import IntroductionCampaign from '@bs/components/views/IntroductionCampaign';
import DarkBgCampaign from '@bs/components/views/DarkBgCampaign';

// Export reference to all modules in an object
export default {
  Alert,
  AlertFooter,
  GeoLocationPopup,
  SidebarAnimation,
  HeroVideos,
  HeroDropdown,
  InteriorHero,
  Lightbox,
  LandingHero,
  BodyVideo,
  StatsPie,
  StatsPercentageCounter,
  Donut,
  DonateBox,
  StatsFwPie,
  FwStatCounter,
  FeaturedContent,
  StatisticsAnimation,
  BodyBackgroundObserver,
  Header,
  FooterPie,
  BackToTop,
  LinkListing,
  ListingCards,
  EmailBlock,
  CtaBlock,
  HomeEmailBlock,
  Dropdown,
  CountrySidebarHeight,
  VideoTwoThreeUp,
  Slideshow,
  TabComponent,
  SocialHighlights,
  Callouts,
  Flagship,
  ImageScroll,
  Timeline,
  Accordion,
  EventSignupForm,
  EmbedForm,
  StoryNavigation,
  MapRegions,
  WorkMap,
  SideNavigation,
  MegaBanner,
  ResourceSidebar,
  CampaignHero,
  ImageGalleryGrid,
  Snapshot,
  HighlightComponent,
  EmergencyStatistics,
  QuoteComponent,
  IntroductionCampaign,
  DarkBgCampaign
};
